<script setup lang="ts">
interface Props {
  tabs: Array<{ id: string; label: string }>
  modelValue: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const selectTab = (tabId: string) => {
  emit('update:modelValue', tabId)
}
</script>

<template>
  <div class="border-b border-gray-200">
    <nav class="-mb-px flex space-x-8">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        :class="[
          'py-2 px-1 border-b-2 font-medium text-sm',
          modelValue === tab.id
            ? 'border-primary-500 text-primary-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
        ]"
        @click="selectTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    </nav>
  </div>
</template>
